import React from 'react'
import PropTypes from 'prop-types'

function ScheduleColumn ({ children, highlight, bottomColumn, onClick }) {
  const classNames = [
    'flex-grow',
    'min-w-4xs',
    'xl:min-w-3xs',
    'relative',
    'w-full',
    highlight ? 'schedule-highlight' : null,
    bottomColumn ? 'schedule-bottom' : null
  ]

  return (
    <div onClick={onClick} className={classNames.join(' ')}>
      <div className='relative z-20 w-full group space-y-2 flex flex-col h-full'>
        {children}
      </div>
    </div>
  )
}

ScheduleColumn.propTypes = {
  /**
     * Controls if the column should be highlighted
     */
  highlight: PropTypes.bool,
  /**
     * Controls if the column should be highlighted
     */
  bottomColumn: PropTypes.bool,
  /**
     * onClick passed to div
     */
  onClick: PropTypes.func
}

export default ScheduleColumn
